import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/SquareSmallFill.tsx
const SquareSmallFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M8.526 6A2.526 2.526 0 0 0 6 8.526v6.948A2.526 2.526 0 0 0 8.526 18h6.948A2.526 2.526 0 0 0 18 15.474V8.526A2.526 2.526 0 0 0 15.474 6H8.526Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { SquareSmallFillIcon };
